import { Raceway } from '@bechtel/sr-types';

export interface FeedbackRacewayFormikState {
  id?: Raceway['id'];
  actualLength: Raceway['actualLength'];
  constructionStatus: Raceway['constructionStatus'];
  numberOfFittings: Raceway['numberOfFittings'];
  installedNoOfSupports: Raceway['installedNoOfSupports'];
  installedTime: Raceway['installedTime'];
  installedBy: Raceway['installedBy'];
  inspectedTime: Raceway['inspectedTime'];
  inspectedBy: Raceway['inspectedBy'];
  tag: Raceway['tag'];
  tagInvalid?: boolean;
}

export const feedbackRacewayInitialValues: FeedbackRacewayFormikState = {
  id: '',
  actualLength: 0.0,
  constructionStatus: '',
  numberOfFittings: 0,
  installedNoOfSupports: 0,
  installedTime: '',
  installedBy: '',
  inspectedTime: '',
  inspectedBy: '',
  tag: '',
  tagInvalid: false,
};
